import { LegalNotice } from 'cpfr-common';
import { AbstractContentState } from '@cp-shared-19/frontend-integration';
import { RootState } from 'store/rootReducer';

export const LegalNoticeContentSelector = (state: RootState): AbstractContentState<LegalNotice> =>
    state.content.legalNotice;
